import React, { FC } from 'react';
import { Image, ImageSourcePropType } from 'react-native';

import { styles } from './styles';

export const TWCButtonIcon: FC<TWCButtonIconProps> = ({ spacing, icon, iconFocused, focused }) => {
  iconFocused = focused ? iconFocused : icon || icon;

  return <Image source={iconFocused} style={[styles.defaultIcon, { marginRight: spacing }]} />;
};

type TWCButtonIconProps = {
  spacing: number;
  focused?: boolean;
  icon: ImageSourcePropType;
  iconFocused?: ImageSourcePropType;
};
